import PropTypes from 'prop-types'
import React, { useState, useImperativeHandle, useRef } from 'react'
import { Colors } from 'Theme'
import styles from './IFDatePicker.module.css'
import { IFText, IFsvg } from 'Components'
import { DatePicker } from 'rsuite'

const IFDatePicker = React.forwardRef(
  ({ title, onDateSelected = () => {} }, ref) => {
    const [value, setValue] = useState(new Date())
    const [isOpen, setIsOpen] = useState(false)
    const clearValue = () => {
      setValue(new Date())
    }

    useImperativeHandle(ref, () => ({
      clearValue,
      isOpen,
    }))
    const pickerRef = useRef()

    return (
      <div ref={pickerRef} className={styles.wrapperContainer}>
        <div className={styles.container}>
          <DatePicker
            container={() => pickerRef?.current}
            className={styles.DateRange}
            onOpen={() => setIsOpen(true)}
            onClose={() => setIsOpen(false)}
            value={value}
            onOk={(value) => {
              setValue(value)
              onDateSelected(value)
            }}
            cleanable={false}
            size="lg"
            placeholder={title}
            renderValue={() => (
              <div>
                <IFText style={{ color: Colors.white }}>{title}</IFText>
              </div>
            )}
          />

          <div
            className={styles.TextWrapper}
            style={{
              backgroundColor: Colors.filterBackground,
            }}
          >
            <IFText className={styles.Text}>
              {/* {Replacing all spaces with &nbsp; for styling} */}
              {title.replaceAll(' ', '\u00a0')}
            </IFText>
            <div>
              <IFsvg.Expand
                height={20}
                width={20}
                fill={Colors.filterIconFilled}
              />
            </div>
          </div>
        </div>
      </div>
    )
  },
)

IFDatePicker.propTypes = {
  title: PropTypes.string.isRequired,
  onDateSelected: PropTypes.func.isRequired,
  initialValue: PropTypes.instanceOf(Date),
}

export default IFDatePicker
